import React from "react";
import { Row, Col, Typography, Space, Button, Modal } from "antd";
import Styles from "./InvalidAddressPopup.module.scss";
import { useWindowSize } from "../../../../../hooks/useWindowSize";
import { GeneralDefinition } from "../../../../../types/ApplicationTypes";

type Props = {
    isNotCovergeZip: boolean;
    handleCancelCoverage: () => void;
};

const InvalidAddressPopup: React.FC<Props> = ({
    isNotCovergeZip,
    handleCancelCoverage
}) => {
    const { width } = useWindowSize();

    return width > GeneralDefinition.MobileView ? (
        <Modal
            onCancel={handleCancelCoverage}
            visible={isNotCovergeZip}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            footer={
                <Row className={Styles.modalContainer}>
                    <Col span={24}>
                        <Row justify="center">
                            <Typography.Text className={Styles.modalHeaderClose}>
                                Invalid Address
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.wheelCharSection}>
                            <Col>
                                <Row justify="center">
                                    <Col>
                                        <Typography.Text className={Styles.modalBodyText}>
                                            Unfortunately, this address is outside of
                                        </Typography.Text>
                                    </Col>
                                </Row>
                                <Row justify="center">
                                    <Col>
                                        <Typography.Text className={Styles.modalBodyText}>
                                            our service area.
                                        </Typography.Text>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row justify="center" className={Styles.wheelCharSection}>
                            <Col>
                                <Space className={Styles.modalBtn}>
                                    <Button
                                        className={Styles.buttonThemeBlueClose}
                                        onClick={handleCancelCoverage}
                                    >
                                        Close
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        />
    ) : (
        <Modal
            onCancel={handleCancelCoverage}
            visible={isNotCovergeZip}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            centered={true}
            footer={
                <Row className={Styles.modalContainer}>
                    <Col span={24}>
                        <Row justify="center">
                            <Typography.Text className={Styles.modalHeaderClose}>
                                Invalid Address
                            </Typography.Text>
                        </Row>
                        <Row justify="center" className={Styles.wheelCharSection}>
                            <Col>
                                <Row justify="center">
                                    <Col span={24} className={Styles.modalBodyText}>
                                        Unfortunately, this address is outside of
                                    </Col>
                                    <Col span={24} className={Styles.modalBodyText}>
                                        our service area.
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row justify="center" className={Styles.wheelCharSection}>
                            <Col>
                                <Space className={Styles.modalBtn}>
                                    <Button
                                        className={Styles.buttonThemeBlueClose}
                                        onClick={handleCancelCoverage}
                                    >
                                        Close
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            }
        />
    );
};

export default InvalidAddressPopup;
